import { atom, selectorFamily } from 'recoil'

import type {
  EngagementScore,
  RecipientsEngagementState,
} from 'Pages/RecipientsList/model'

export const recipientsEngagementState = atom<RecipientsEngagementState>({
  key: 'recipientsList_recipientsEngagementState',
  default: {
    status: 'initial',
    items: [],
  },
})

export const recipientEngagementState = selectorFamily<EngagementScore, number>(
  {
    key: 'recipientsList_recipientEngagementState',
    get:
      (idRecipient: number) =>
      ({ get }) => {
        const { items } = get(recipientsEngagementState)

        const item = items.find((o) => o.idRecipient === idRecipient)

        if (item !== undefined) {
          return item.score
        }

        return 'Abandoned'
      },
  },
)
